import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

export type ReasonsModalProps = {
  onClose: () => void;
  selectReason: (reason: string) => void;
};

const REASONS = [
  "minor",
  "animal-cruelty",
  "fraud-scam",
  "harassment",
  "pedocriminality",
  "prostitution",
  "illicit-goods",
  "terrorisme",
  "violence-physical-integrity",
  "sexual-violence",
  "intellectual-property-privacy",
];

const ReasonsModal: React.FC<ReasonsModalProps> = ({ onClose, selectReason }) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  const modalContent = (
    <div className="reasons-modal-overlay" onClick={handleOverlayClick}>
      <div className="reasons-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="reasons-modal-container">
          <div className="reasons-modal-title">{t("reason-for-reporting")}</div>

          {REASONS.map((reason) => (
            <button
              type="button"
              className="reasons-actions-button"
              onClick={() => {
                onClose?.();
                selectReason(reason);
              }}
            >
              {t(reason)}
            </button>
          ))}

          <button
            type="button"
            className="reasons-actions-button cancel-button"
            onClick={() => {
              onClose?.();
            }}
          >
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ReasonsModal;
